export class CreateActivityUserReportDto {}
